import { Particles as TsParticles } from 'react-tsparticles'
import { loadFull } from 'tsparticles'
import { Engine, ISourceOptions } from 'tsparticles-engine'

const particleConf: ISourceOptions = {
  fullScreen: {
    enable: false,
  },
  interactivity: {
    events: {
      onDiv: {
        selectors: 'span',
        enable: true,
        mode: 'bounce',
        type: 'rectangle',
      },
    },
  },
  particles: {
    number: {
      value: 9,
      density: {
        enable: false,
        value_area: 1525.8919341219544,
      },
    },
    color: {
      value: '#00b1e9',
    },
    shape: {
      type: 'circle',
      stroke: {
        width: 0,
        color: '#000000',
      },
      polygon: {
        nb_sides: 6,
      },
    },
    opacity: {
      value: 1,
      random: false,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.1,
        sync: false,
      },
    },
    size: {
      value: 12,
      random: {
        enable: true,
        minimumValue: 3,
      },
      anim: {
        enable: false,
        speed: 40,
        size_min: 0.1,
        sync: false,
      },
    },
    line_linked: {
      enable: true,
      distance: 126.26362266116361,
      color: '#7f7f7f',
      opacity: 0.5,
      width: 1,
    },
    move: {
      enable: true,
      speed: 4,
      direction: 'none',
      random: true,
      straight: false,
      out_mode: 'bounce',
      bounce: false,
      attract: {
        enable: true,
        rotateX: 1972.8691040806818,
        rotateY: 1341.5509907748635,
      },
    },
  },
  detectRetina: true,
}

const particlesInit = async (main: Engine) => {
  await loadFull(main)
}

const Particles = () => {
  return (
    <TsParticles
      className="h-full"
      init={particlesInit}
      options={particleConf}
    />
  )
}

export default Particles
